export default {
  foo: 'bar',
};
